
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"24","viewBox":"0 0 512 512","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"ESSENTIAL UI"}},[_c('path',{attrs:{"d":"M256 0C114.62 0 0 114.61 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0z","fill":"#f9973e"}}),_c('path',{attrs:{"d":"M120.56 400.82c153.63 0 278.17-124.54 278.17-278.16a277.77 277.77 0 00-14.28-88.14A254.83 254.83 0 00256 0C114.62 0 0 114.62 0 256a254.81 254.81 0 0036.57 131.91 278.14 278.14 0 0083.99 12.91z","fill":"#fca84c"}}),_c('path',{attrs:{"d":"M405.44 256a28.36 28.36 0 01-28.36 28.36h-92.72v92.72A28.36 28.36 0 01256 405.44a28.36 28.36 0 01-28.36-28.36v-92.72h-92.72A28.36 28.36 0 01106.56 256a28.36 28.36 0 0128.36-28.36h92.72v-92.72A28.36 28.36 0 01256 106.56a28.36 28.36 0 0128.36 28.36v92.72h92.72A28.36 28.36 0 01405.44 256z","fill":"#fff"}})])])
          )
        }
      }
    